import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import type { OnboardingRunSummary } from "@/api/types";
import { IntakeForm } from "@/components/onboarding/IntakeForm";
import { Button } from "@/components/ui/button";

/** Full-screen intake page. On successful create, navigate to the
 * detail page and start auto-execution there. */
export function OnboardingNewPage() {
	const navigate = useNavigate();
	const [_created, _setCreated] = useState<OnboardingRunSummary | null>(null);
	// note: _created kept so tests can observe state even when we
	// navigate away synchronously.

	function onCreated(run: OnboardingRunSummary) {
		_setCreated(run);
		navigate(`/onboarding/${run.id}`, { replace: true });
	}

	return (
		<div className="min-h-screen bg-muted/20">
			<header className="border-b bg-background">
				<div className="mx-auto flex max-w-4xl items-center justify-between p-4">
					<Button variant="ghost" size="sm" asChild>
						<Link to="/">
							<ArrowLeft className="mr-1 h-4 w-4" aria-hidden />
							Cancel
						</Link>
					</Button>
					<h1 className="text-sm font-medium text-muted-foreground">New client onboarding</h1>
					<span className="w-20" />
				</div>
			</header>
			<main className="mx-auto max-w-4xl p-6">
				<IntakeForm onCreated={onCreated} />
			</main>
		</div>
	);
}
